import { css, keyframes } from "@emotion/core";
import styled from "@emotion/styled";
import React from "react";

export const Title = styled.div(
  ({ theme: { designTokens: DT }, size = 12, width = 100 }) => `
            line-height: 20px;
            height: 22px;
            font-weight: 600;
            font-size: ${size}px;
            width: ${width}px;
            margin-right: 16px;
            color:  ${DT.T_COLOR_TEXT_DEFAULT_DARK};
        `
);
export const Item = styled.div(
  () => `
           display: flex;
           align-items: center;
        `
);
export const Content = styled.div(
  ({ theme: { designTokens: DT } }) => `
        width: 228px;
        height: 22px;
        font-size: 14px;
        font-weight: 400;
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
        line-height: 22px;
        `
);
export const Divider = styled.div(
  ({ theme: { designTokens: DT } }) => `
        width: 100%;
        height: 1px;
        margin: 16px 0;
        background: ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
        `
);
export const ICON = styled.div(
  ({ theme: { designTokens: DT }, isMobile }) => `
            width: 32px;
            height: 32px;
            text-align: center;
            line-height: 32px;
            border-radius: 0 0 0 32px;
            color: ${DT.T_COLOR_TEXT_SUCCESS};
            background: ${isMobile ? "#E6FFED" : ""};
        `
);
export const TextDiv = styled.div(
  ({
    theme: { designTokens: DT },
    height = 20,
    size = 12,
    color = "dark",
    weight = 400,
    bottom = 0,
    top = 0,
  }) => `
            line-height: ${height}px;
            height: ${height}px;
            font-size: ${size}px;
            font-weight: ${weight};
            text-align: center;
            color: ${
              color === "dark"
                ? DT.T_COLOR_TEXT_DEFAULT_DARK
                : DT.T_COLOR_TEXT_DEFAULT_LIGHT
            };
            margin-bottom: ${bottom}px;
            margin-top: ${top}px;
        `
);
export const TextSpan = styled.span(
  ({
    left = 0,
    right = 0,
    top = 0,
    bottom = 0,
    color = "dark",
    theme: { designTokens: DT },
  }) => `
            margin-top: ${top}px;
            margin-bottom: ${bottom}px;
            margin-left: ${left}px;
            margin-right: ${right}px;
            color: ${
              color === "dark"
                ? DT.T_COLOR_TEXT_DEFAULT_DARK
                : DT.T_COLOR_TEXT_DEFAULT_LIGHT
            }
        `
);

const specAnimation = keyframes`
    0% {
        transform: translate3d(-9px, 0px, 0px);
        animation-timing-function: ease-in-out;
    }
    7% {
        transform: translate3d(-18px, 0px, 0px);
        animation-timing-function: linear;
    }
    92% {
        transform: translate3d(-18px, 0px, 0px);
        animation-timing-function: ease-in-out;
    }
    100% {
        transform: translate3d(-9px, 0px, 0px);
        animation-timing-function: linear;
    }
`;

export const LinkDiv = styled.div(
  ({ theme: { designTokens: DT } }) => css`
    display: flex;
    width: 100%;
    height: 60px;
    font-size: 16px;
    border-bottom: 1px solid ${DT.T_COLOR_LINE_DEFAULT_DARK};
    margin-bottom: 24px;
    .common {
      flex: 1;
      height: 100%;
      line-height: 60px;
      text-align: center;
      font-weight: 600;
      color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
      .divider {
        flex: 1;
        height: 4px;
        background: ${DT.T_BUTTON_PRIMARY_COLOR_BG_DEFAULT};
        border-radius: 2px;
        margin-top: -2px;
      }
    }
    .spec {
      flex: 1;
      height: 100%;
      color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
      text-align: center;
      line-height: 60px;
      cursor: pointer;
    }
    .spec:hover {
      color: ${DT.T_COLOR_TEXT_PRIMARY_DEFAULT} !important;
    }

    .spec-animation {
      animation: 4.6s linear 1 normal forwards ${specAnimation};
    }
  `
);
export const PopPassTip = styled.div(
  ({ theme: { designTokens: DT } }) => `
            max-width: 219px;
            font-size: 12px;
            line-height: 20px;
            color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
            word-break: break-all;
        `
);
export const BtnText = styled.div(
  ({ theme: { designTokens: DT }, size = 16 }) =>
    `
        height: 24px;
        font-size: ${size}px;
        font-weight: 600;
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
        line-height: 24px;
        margin-left: 12px;
        max-width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        .btn-input {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space:nowrap;
        }
        `
);

export const CampusText = styled.div(
  ({ theme: { designTokens: DT } }) => `
            font-size: 16px;
            font-weight: 600;
            height: 24px;
            line-height: 24px;
            color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
            border-right: 1px solid gray;
            padding: 0 16px 0 8px;
            .btn-input {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space:nowrap;
            }

        `
);
export const CampusWarpper = styled.div(
  ({ theme: { designTokens: DT } }) => `
        .campus-icon {
            background: url('https://static.ucloud.cn/3ace422cb04b8c555344dba8c612112b.png') no-repeat top left;
            width: 16px;
            height: 11px;
            box-shadow: ${DT.T_SHADOW_BLOCK_DEFAULT_SM};
        }
        .campus-icon.cn {
            background-position: 0 0;
        }
        .campus-icon.hk {
            background-position: 0 -13px;
        }
        .campus-icon.sg {
            background-position: 0 -26px;
        }
        .campus-icon.tw {
            background-position: 0 -39px;
        }

        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
            .campus-icon {
                background: url('https://static.ucloud.cn/0e3eb1396482b1ab988f49307e5c4e66.png') no-repeat top left;
                background-size: 16px 52px;
                box-shadow: ${DT.T_SHADOW_BLOCK_DEFAULT_SM};
            }
        }
        `
);
export const FlagIcon = ({ icon, value }) => {
  return (
    <CampusWarpper>
      <div style={{ minWidth: "110px", display: "flex", alignItems: "center" }}>
        <div className={`campus-icon ${icon}`} style={{ marginRight: "4px" }} />
        <div>{value}</div>
      </div>
    </CampusWarpper>
  );
};

const fadeIn = keyframes`
    0% {
        opacity: 0;
        transform: translateY(200px);
    }
    100% {
        opacity: 1;
         transform: translateY(0);
    }
`;

export const FadeInCard = styled.div(
  () => css`
    animation: 1s ${fadeIn} ease-out;
  `
);
export const LinKs = styled.div(
  ({ theme: { designTokens: DT } }) => `
            color: ${DT.T_COLOR_TEXT_PRIMARY_DEFAULT};
            .line {
              color: ${DT.T_COLOR_LINE_DEFAULT_LIGHT}
            }
        `
);
const compousTipAnimation = keyframes`
    0% {
      transform: translate3d(-8px, 0px, 0px);
      opacity: 0;
      animation-timing-function: ease-in-out;
    }

    8% {
      transform: translate3d(16px, 0px, 0px);
      opacity: 1;
      animation-timing-function: ease-in-out;
    }
    17% {
      transform: translate3d(-8px, 0px, 0px);
      opacity: 1;
      animation-timing-function: ease-in-out;
    }

    26% {
      transform: translate3d(16px, 0px, 0px);
      opacity: 1;
      animation-timing-function: ease-in-out;
    }
    34% {
      transform: translate3d(0px, 0px, 0px);
      opacity: 1;
      animation-timing-function: linear;
    }
    86% {
      transform: translate3d(0px, 0px, 0px);
      opacity: 1;
      animation-timing-function: ease-in-out;
    }
    91% {
      transform: translate3d(-6px, 0px, 0px);
      opacity: 1;
      animation-timing-function: ease-in-out;
    }
    100% {
      transform: translate3d(24px, 0px, 0px);
      opacity: 0;
      animation-timing-function: linear;
    }
`;
export const CompusTipContainer = styled.div(
  ({ theme: { designTokens: DT } }) => css`
    display: flex;
    align-items: center;
    position: absolute;
    top: 14px;
    left: 480px;
    opacity: 0;
    animation: 4.6s linear 1 normal forwards ${compousTipAnimation};

    .uc-compus-wrapper {
      padding: 4px 12px;
      background: ${DT.T_COLOR_BG_PRIMARY_1};
      font-size: 12px;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      width: 88px;
      box-shadow: ${DT.T_SHADOW_BUTTON_PRIMARY};
      border-radius: 2px;
    }

    .uc-compus-triangle {
      width: 0;
      height: 0;
      border-top: 3px solid transparent;
      border-right: 6px solid ${DT.T_COLOR_BG_PRIMARY_1};
      border-bottom: 3px solid transparent;
    }
  `
);

export const CompusTipMobileContainer = styled.div(
  ({ theme: { designTokens: DT }, isMobile }) => css`
    display: flex;
    align-items: center;
    position: absolute;
    top: 32px;
    left: 280px;
    opacity: 0;
    animation: 124.6s linear 1 normal forwards ${compousTipAnimation};

    ${isMobile
      ? `
      flex-direction: column;
      top: 32px;
      left: 280px;
    `
      : ""}

    .uc-compus-wrapper {
      padding: 4px 8px;
      background: ${DT.T_COLOR_BG_PRIMARY_1};
      font-size: 12px;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      min-width: 24px;
      box-shadow: ${DT.T_SHADOW_BUTTON_PRIMARY};
      border-radius: 2px;
    }

    .uc-compus-triangle {
      width: 0;
      height: 0;

      ${isMobile
        ? `
        border-left: 6px solid transparent;
        border-bottom: 3px solid ${DT.T_COLOR_BG_PRIMARY_1};
        border-right: 6px solid transparent;

      `
        : `
        border-top: 3px solid transparent;
        border-right: 6px solid ${DT.T_COLOR_BG_PRIMARY_1};
        border-bottom: 3px solid transparent;
        `}
    }
  `
);

export const LoginButtonContainer = styled.div(
  ({ theme: { designTokens: DT } }) => `
        position: relative;
        .pass-login-diasbled {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: ${DT.T_BUTTON_COMMON_COLOR_MASK};
            opacity: 0.5;
        }
        `
);

export const AccoutLoginContainer = styled.div(
  ({ theme: { designTokens: DT } }) => `
        text-align: center;
        margin-top: 24px;
        font-size: 12px;
        cursor: pointer;
        background: ${DT.T_COLOR_BG_DEFAULT_LIGHT};
        border-radius: 2px;
        padding: 14px 0;
        `
);

// 选择账号
export const SelectAccountContainer = styled.div(
  ({ theme: { designTokens: DT } }) => `
        display: flex;
        flex-direction:column;
        .account-title-box {
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            font-size: 24px;
            font-weight: bold;
            &::before {
                width: 3px;
                height: 24px;
                margin-right: 12px;
                display: inline-block;
                border-radius: 2px;
                background-color: ${DT.T_COLOR_BG_PRIMARY_1};
                content: '';
            }
        }
        .uc-fe-radio {
            border-bottom: none !important;
            border-radius: 2px;
        }
        .uc-fe-radio-checked {
            background: #fff !important;
        }
        .uc-fe-radio-styletype-list:last-of-type {
            margin-bottom: 0px;
        }
        .uc-fe-radio-checked .uc-fe-radio-content {
            font-weight: normal !important;
        }
        .account-list-box {
            width: 400px;
            height: 60px;
            margin-bottom: 8px;
            border-radius: 2px;
            border: 1px solid ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
            background-color: ${DT.T_COLOR_BG_DEFAULT_LIGHT};
            box-sizing: border-box;
            display: flex;
            align-items: center;
            &:hover {
                border: 1px solid ${DT.T_COLOR_BG_PRIMARY_2};
            }
        }
        .account-radio {
            width: 100%;
            height: 100%;
            margin-bottom: 0px !important;
            padding: 0 20px;
            box-sizing: border-box;
        }
        .account-info-box {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            box-sizing: border-box;

            .account-name {
                flex-grow: 1;
                font-size: 14px;
                overflow: hidden;
                color: ${DT.T_COLOR_BRAND_BLACK};
            }
            .account-type {
                flex-shrink: 0;
                padding: 0 8px;
                margin-left: 16px;
                line-height: 20px;
                border-radius: 2px;
                font-size: 12px;
                color: #fff;
            }
            .t-main {
                background-color: ${DT.T_COLOR_BG_PRIMARY_1};
            }
            .t-sub {
                background-color: ${DT.T_COLOR_LEGEND_PURPLE_5};
            }
        }
        .active-account {
            border: 1px solid ${DT.T_COLOR_BG_PRIMARY_2};
        }
        .notice-box {
            width: 392px;
            padding-top: 12px;
        }
    `
);

export const InputWrapper = styled.input(({ theme: { designTokens: DT } }) => {
  return `
      position: relative;
      box-sizing: border-box;
      max-width: 100%;
      border-radius: ${DT.T_CORNER_SM};
      color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
      fill: currentColor;
      border: ${DT.T_LINE_WIDTH_BASE} solid ${DT.T_COLOR_LINE_DEFAULT_DARK};
      box-shadow: ${DT.T_SHADOW_INSET_DEFAULT};
      background: ${DT.T_INPUT_COLOR_BG_DEFAULT};
      transition: .18s cubic-bezier(.4,0,.2,1);
      display:  inline-flex;
      vertical-align: middle;
      align-items: center;

      :hover {
          color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
          border-color: ${DT.T_COLOR_LINE_DEFAULT_DARK};
          background: ${DT.T_INPUT_COLOR_BG_ACTIVE};
      }
  `;
});

export const SocialRegisterTitle = styled.div(
  ({ theme: { designTokens: DT } }) => {
    return `
        display: flex;
        align-items: center;
        justify-content: space-between;
        .social-title-left {
            display: flex;
            align-items: center;
            font-size: 24px;
            color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
            font-weight: 600;
            &::before {
                width: 3px;
                height: 24px;
                display: inline-block;
                border-radius: 2px;
                margin-right: 12px;
                background-color: ${DT.T_COLOR_TEXT_PRIMARY_DEFAULT};
                content: "";
            }
        }
        .social-title-right {
            font-size: 14px;
            color: ${DT.T_COLOR_TEXT_PRIMARY_DEFAULT};
            cursor: pointer;
        }
    `;
  }
);


export const RegisterTabWrapper = styled.div(
  ({ theme: { designTokens: DT } }) => {
    return `
        .uc-fe-tabs-nav-container {
          .uc-fe-tabs-tab-active {
              color: ${DT.T_COLOR_TEXT_DEFAULT_DARK}!important;
              :hover {
                  color: ${DT.T_COLOR_TEXT_DEFAULT_DARK}!important;
              }
          }

          .uc-fe-tabs-tab {
            :hover {
                color: ${DT.T_COLOR_TEXT_DEFAULT_DARK}!important;
            }
          }
        }
    `;
  }
);



// WEBPACK FOOTER //
// src/pc/components/style.jsx